/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable indent */
/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable function-paren-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable quotes */
import { Fragment, useEffect, useState } from "react";
import { SearchIcon } from "../../../assets/icons";
import CoaxImage from "../../../assets/images/coax.png";
import FiberImage from "../../../assets/images/fiber.png";
import { PAGES } from "../../../common/constants/common";
import { PAGINATION } from "../../../common/constants/pagination";
import trackClickHandler from "../../../common/helpers/trackClickHandler";
// import trackHistory from "../../../common/helpers/trackHistory";
import { appInsightsService } from "../../../services/appInsights/appInsights";
import { Button, Col, Input, Link, Loader, Row, Separator, StatusLabel, Table, Text, Title } from "../../../components/ui";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { userSelector } from "../../auth/auth.selectors";
import styles from "./MyMultimediaOffer.module.scss";
import MyMultimediaOfferCarousel from "./MyMultimediaOfferCarousel";
import { fetchMyMultimediaOffer, fetchMyMultimediaOto } from "./service/myMultimediaOffer.actions";
import { INTERNET_COAXAL, INTERNET_OPTIQ, INTERNET_STATUS } from "./service/myMultimediaOffer.constants";
import {
  externalClientSelector,
  isFetchingMyMultimediaOfferSelector,
  myMultimediaOfferSelector,
  otoSelector,
} from "./service/myMultimediaOffer.selectors";

function getLabelStatus(label) {
  switch (label) {
    case INTERNET_COAXAL.ACTIVE_TVT:
      return "Offre TVT Basic";
    case INTERNET_COAXAL.ACTIVE_TVT_TV_PLUS:
      return "Offre TV+";
    case INTERNET_COAXAL.ACTIVE_PARTNER:
    case INTERNET_OPTIQ.ACTIVE_PARTNER:
    case INTERNET_OPTIQ.AVAILABLE:
    case INTERNET_COAXAL.LEADED:
      return "Disponible";
    case INTERNET_OPTIQ.TVT_PRO:
      return "Offre TVT Pro";
    case INTERNET_COAXAL.UNAVAILABLE:
    case INTERNET_OPTIQ.UNAVAILABLE:
    case INTERNET_STATUS.UNAVAILABLE:
      return "Indisponible";

    default:
      return "Indisponible";
  }
}

const MyMultimediaOffer = () => {
  const location = window.location.href;
  appInsightsService.trackPageView(location);

  const dispatch = useAppDispatch();
  const { id, scenario } = useAppSelector(userSelector);
  const isFetching = useAppSelector(isFetchingMyMultimediaOfferSelector);
  const addresses = useAppSelector(myMultimediaOfferSelector);
  const [showAllAddresses, setShowAllAddresses] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [selectedAddress, setSelectedAddress] = useState({} as any);
  const internetCoaxial = selectedAddress?.internetCoaxial;
  const internetOptiq = selectedAddress?.internetOptiq;
  const otoPlug = selectedAddress?.oto;
  const [blockTwoImage, setBlockTwoImage] = useState("");
  const [blockTwoText, setBlockTwoText] = useState("");
  const [optiqName, setOptiqName] = useState("");
  const [coaxName, setCoaxName] = useState("");
  const [otoPlugName, setOtoPlugName] = useState("");
  // TODO: set isMultimediaPageReady to false if it needs to be hidden
  const [isMultimediaPageReady, setIsMultimediaPageReady] = useState(true);

  function hasMoreThanOneValue(arr: any[]): boolean {
    return Array.isArray(arr) && arr.length > 1;
  }

  useEffect(
    () => () => {
      // trackHistory(sessionStorage.getItem("clicks") ?? 0, location);
      sessionStorage.removeItem("clicks");
    },
    []
  );

  const addressesToShow = addresses
    .slice(
      0,
      showAllAddresses
        ? addresses.length
        : PAGINATION.MULTIMEDIA_ADDRESSES_PER_PAGE
    )
    .filter((address) =>
      address.address?.toLowerCase().includes(searchValue.trim().toLowerCase())
    );

  const onAddressSelect = (event) => {
    trackClickHandler();
    const objectId = event.target.value;
    const newSelectedAddress = addressesToShow.find(
      (address) => `${address.objectId}-${address.tariffId}` === objectId
    );
    if (newSelectedAddress) {
      setSelectedAddress(newSelectedAddress);
      // dispatch(fetchMyMultimediaOto(Number(objectId)));
    }
  };

  const remainingAddressess =
    addresses.length - PAGINATION.MULTIMEDIA_ADDRESSES_PER_PAGE;

  const renderBlockTwo = (
    <>
      <Title
        isBoxTitle
        usePrimaryColor
        className={styles.multimediaNetworkTitle}
        level={3}
      >
        Raccordement Coaxial
      </Title>
      <Separator size="medium" />
      <img
        alt="Coaxial"
        className={styles.fiberImage}
        src={CoaxImage}
      />
      <Separator size="medium" />
      {(internetCoaxial === INTERNET_COAXAL.ACTIVE_TVT) && (
        <>
          <Text align="center">Vous bénéficiez actuellement de notre offre raccordement multimédia TVT Basic : TV, téléphonie (seules les communications sont payantes) et Internet 50 Mbit/s.</Text>
          <Separator size="medium" />
          <Link
            isTvt
            href="https://www.sie.ch/multimedia/reseau-multimedia-263"
            onClick={trackClickHandler}
          >
            En savoir plus
          </Link>
        </>
      )}
      {internetCoaxial === INTERNET_COAXAL.ACTIVE_TVT_TV_PLUS && (
        <>
          <Text align="center">Connexion coaxiale activée. Vous bénéficiez actuellement d’un accès TV.</Text>
          <Separator size="medium" />
          <Link
            isTvt
            href="https://www.sie.ch/multimedia/reseau-multimedia-263"
            onClick={trackClickHandler}
          >
            En savoir plus
          </Link>
        </>
      )}
      {(internetCoaxial === INTERNET_COAXAL.AVAILABLE ||
        internetCoaxial === INTERNET_COAXAL.LEADED ||
        internetCoaxial === INTERNET_COAXAL.ACTIVE_PARTNER) && (
        <Text align="center">
          Vous possédez un raccordement coaxial. Si vous souhaitez l’utiliser pour internet, TV et téléphone, merci de&nbsp;
          <Link isTvt to={PAGES.CONTACT_AND_FORMS} onClick={trackClickHandler}>nous contacter</Link>
        </Text>
      )}
      {(internetCoaxial === INTERNET_COAXAL.UNAVAILABLE ||
        internetCoaxial === undefined) && (
        <>
          <Text align="center">Vous ne possédez actuellement aucun raccordement coaxial.</Text>
          <Separator size="medium" />
          <Link
            isTvt
            to={PAGES.CONTACT_AND_FORMS}
            onClick={trackClickHandler}
          >
            Contactez nous
          </Link>
          pour plus d’informations sur nos réseaux.
        </>
      )}
    </>
  );

const renderBlockThree = (
  <>
    <Title
      isBoxTitle
      usePrimaryColor
      className={styles.multimediaNetworkTitle}
      level={3}
    >
      Raccordement Fibre Optique
    </Title>
    <Separator size="medium" />
    <img
      alt="Fiber"
      className={styles.fiberImage}
      src={FiberImage}
    />
    <Separator size="medium" />
    {(internetOptiq === INTERNET_OPTIQ.AVAILABLE ||
      internetOptiq === INTERNET_OPTIQ.ACTIVE_PARTNER) && (
      <>
        {otoPlug && (
          <>
            <Text align="center">Numéro OTO Fibre Optique:</Text>
            <Text isBold align="center">{otoPlug}</Text>
            <Separator size="small" />
          </>
        )}
        <Text align="center">Raccordement Fibre Optique disponible.</Text>
        <Separator size="medium" />
        <Link
          isTvt
          to={PAGES.CONTACT_AND_FORMS}
          onClick={trackClickHandler}
        >
          Contactez-nous
        </Link>
        <Text align="center">pour passer à la fibre et profiter d’un accès Internet ultra-haut débit, jusqu’à 10 Gbit/s.</Text>
      </>
    )}
    {(internetOptiq === INTERNET_OPTIQ.UNAVAILABLE ||
      internetOptiq === undefined) && (
      <>
        <Text align="center">Pas de raccordement Fibre Optique disponible.</Text>
        <Link
          isTvt
          href="https://www.sie.ch/multimedia/fibre-optique-256"
          onClick={trackClickHandler}
        >
          Vérifier si vous êtes éligible à la fibre
        </Link>
        <Separator size="medium" />
        <Link
          isTvt
          to={PAGES.CONTACT_AND_FORMS}
          onClick={trackClickHandler}
        >
          Contactez nous
        </Link>
        pour plus d’informations sur l’arrivée de la Fibre Optique chez vous.
      </>
    )}
    {(internetOptiq === INTERNET_OPTIQ.TVT_PRO) && (
      <>
        {otoPlug && (
          <>
            <Text align="center">Numéro OTO Fibre Optique:</Text>
            <Text isBold align="center">{otoPlug}</Text>
            <Separator size="small" />
          </>
        )}
        <Text align="center">Vous bénéficiez d’un abonnement TVT Pro sur notre réseau Fibre Optique.</Text>
        <Separator size="medium" />
        <Link
          isTvt
          to={PAGES.CONTACT_AND_FORMS}
          onClick={trackClickHandler}
        >
          Contactez-nous
        </Link>
        <Text align="center">pour toute question relative à vos services TVT PRO.</Text>
      </>
    )}
  </>
);

  useEffect(() => {
    dispatch(fetchMyMultimediaOffer());
  }, []);

  useEffect(() => {
    // setBlockTwoOffer();

    if (selectedAddress?.internetOptiq) {
      setOptiqName(selectedAddress?.internetOptiq);
    } else {
      setOptiqName("Indisponible");
    }

    if (selectedAddress?.internetCoaxial) {
      setCoaxName(selectedAddress?.internetCoaxial);
    } else {
      setCoaxName("Indisponible");
    }

    if (selectedAddress?.otoPlug) {
      setOtoPlugName(selectedAddress?.otoPlug);
    } else {
      setOtoPlugName("Indisponible");
    }
  }, [internetCoaxial, internetOptiq]);

  useEffect(() => {
    setSelectedAddress(addresses[0]);
  }, [addresses]);

  if (isFetching) {
    return <Loader />;
  }

  return (
    <>
      <Title>Raccordements multimédia</Title>
      <Separator />

      {/* BLOCK 1 - Address */}
      <Row ignorePageContentPadding align="start" direction="column">
        {hasMoreThanOneValue(addressesToShow) && (
          <>
            <Col hasPageContentOffset>
              <Title isBoxTitle usePrimaryColor level={3}>
                Sélectionner vos raccordements
              </Title>
            </Col>
            <Col hasPageContentOffset lg={7} md={6} span={12}>
              <Input
                placeholder="Recherche par adresse"
                prefix={<SearchIcon />}
                onChange={(e) => setSearchValue(e.target.value)}
                onFocus={trackClickHandler}
              />
            </Col>
            <Separator size="large" />
          </>
        )}
        <Col hasPageContentOffset span={12}>
          <Table
            selectableRows
            columns={[
              { dataIndex: "address", title: "Adresse" },
              { dataIndex: "internetCoaxial", title: "Internet : Coaxial" },
              { dataIndex: "internetFibreOptique", title: "Internet : Fibre Optique" },
            ]}
            data={addressesToShow.map((address) => ({
              key: `${address.objectId}-${address.tariffId}`,
              address: address.address,
              internetCoaxial: (<StatusLabel label={getLabelStatus(address.internetCoaxial)} status={getLabelStatus(address.internetCoaxial)} />),
              internetFibreOptique: (<StatusLabel label={getLabelStatus(address.internetOptiq)} status={getLabelStatus(address.internetOptiq)} />),
            }))}
            defaultSelectedRow={0}
            id="myMultimediaTable"
            noDataMessage="Aucun raccordement multimédia disponible à votre adresse."
            onRowSelect={onAddressSelect}
          />
          {!showAllAddresses &&
            addresses?.length > PAGINATION.MULTIMEDIA_ADDRESSES_PER_PAGE && (
              <div className={styles.displayAllButtonWrap}>
                <Button
                  buttonStyle="linkButton"
                  className={styles.displayAllButton}
                  onClick={() => {
                    trackClickHandler();
                    setShowAllAddresses(true);
                  }}
                >
                  Afficher tout ({remainingAddressess})
                </Button>
              </div>
            )}
        </Col>
      </Row>
      {/* BLOCK 1 END */}

      <Separator size="large" />
      <Row
        wrapForMobile
        align="stretch"
        className={styles.connectionBlocks}
        justify="space-between"
        wrap={false}
      >
        {/* BLOCK 2 - Raccordements Coaxial */}
        <Col isContentBox className={styles.connectionBox} md={6} span={12}>
          { renderBlockTwo }
        </Col>
        {/* BLOCK 3 - Raccordements Fibre Optique */}
        <Col isContentBox className={styles.connectionBox} md={6} span={12}>
          { renderBlockThree }
        </Col>
      </Row>
      <Separator size="large" />
      <MyMultimediaOfferCarousel />
    </>
  );
};

export default MyMultimediaOffer;
